import { API } from "@/lib/api";

// Chunked, resumable upload of a Blob to the backend with progress + retry.
export async function chunkedUpload(blob, filename, contentType, onProgress) {
  const initRes = await fetch(`${API}/uploads/init`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ filename, content_type: contentType, total_size: blob.size }),
  });
  if (!initRes.ok) throw new Error("Could not start upload");
  const { upload_id, chunk_size } = await initRes.json();

  const total = Math.max(1, Math.ceil(blob.size / chunk_size));
  for (let idx = 0; idx < total; idx++) {
    const slice = blob.slice(idx * chunk_size, (idx + 1) * chunk_size);
    let attempt = 0;
    while (true) {
      try {
        const r = await fetch(`${API}/uploads/${upload_id}/chunk?idx=${idx}`, {
          method: "PUT",
          headers: { "Content-Type": "application/octet-stream" },
          body: slice,
        });
        if (!r.ok) throw new Error("chunk failed");
        break;
      } catch (e) {
        attempt++;
        if (attempt > 4) throw new Error("Upload failed — please check your connection and try again");
        await new Promise((res) => setTimeout(res, 700 * attempt));
      }
    }
    if (onProgress) onProgress(Math.round(((idx + 1) / total) * 100));
  }

  const compRes = await fetch(`${API}/uploads/${upload_id}/complete`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ total_chunks: total }),
  });
  if (!compRes.ok) throw new Error("Could not finalize upload");
  return compRes.json();
}

export async function uploadPhoto(file) {
  const fd = new FormData();
  fd.append("file", file);
  const r = await fetch(`${API}/uploads/simple`, { method: "POST", body: fd });
  if (!r.ok) throw new Error("Photo upload failed");
  return r.json();
}

export function pickMime(audioOnly) {
  const vids = ["video/webm;codecs=vp9,opus", "video/webm;codecs=vp8,opus", "video/webm", "video/mp4"];
  const auds = ["audio/webm;codecs=opus", "audio/webm", "audio/mp4"];
  const list = audioOnly ? auds : vids;
  for (const t of list) {
    if (typeof MediaRecorder !== "undefined" && MediaRecorder.isTypeSupported && MediaRecorder.isTypeSupported(t)) return t;
  }
  return "";
}
